// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"app-info-dialog_modalTitle_27ltp","modalButtons":"app-info-dialog_modalButtons_Neyhd","okBtn":"app-info-dialog_okBtn_2BT62"};